import {
  RecurringDocumentStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";

const MUTABLE_STATUSES: Array<RecurringDocumentStatus | undefined> = [
  RecurringDocumentStatus.DRAFT,
  RecurringDocumentStatus.ACTIVE
];

export const selectorIsRecurringInvoiceMutable = (
  recurringInvoice: RecurringInvoice
): boolean => MUTABLE_STATUSES.includes(recurringInvoice.status);
